import classnames from 'clsx';

import { FlexColumn } from 'ui-components/components/flex';

import style from './card.module.less';

import type { CardComponent } from './card-types';

export const Card: CardComponent = ({ className, children }) => {
  return <FlexColumn className={classnames(style['card-wrapper'], className)}>{children}</FlexColumn>;
};
